import React from "react";
 

import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Badge } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback, useContext } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS ,LOCAL_PATHS} from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import AppContext from "../../../AppContext";
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import CardBox from "../../../components/CardBox";
import { ListEmployeeApi } from "../../../services/Api";

const AssignStaffTax = (props) => {
  const global = useContext(AppContext);
 
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const gridRef2 = useRef();

  const [gridApi, setGridApi] = useState(null);
 const [Processing, setProcessing] = useState(false)
  const [status, setstatus] = useState('')

const [selected_taxes, setSelected_taxes] = useState([])
const [selected_staff, setSelected_staff] = useState([])


 const [taxes, setTaxes] = useState([])
const [showModal, setshowModal] = useState(false)
const [showDeleteModal, setShowDeleteModal] = useState(false)
const [showTaxesModal, setShowTaxesModal] = useState(false)
const [selectedStaffTaxes, setSelectedStaffTaxes] = useState([])
const [selectedStaffName, setSelectedStaffName] = useState('')
const [selected_payroll, setselected_payroll] = useState(null)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);
 
  useEffect(() => {
 
    fetch_employee_data();
    get_taxes();
    return () => {};
  }, []);

  const fetch_employee_data = () => {
    setProcessing(true);

    ListEmployeeApi()
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const get_taxes = (_status) => {
    setIsLoading(true);
 
    genericGet(ENDPOINTS.LIST_TAXES)
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setTaxes(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  const saveTaxes =  (e) => {
    setIsLoading(true)
    e?.preventDefault();

let _data=[];
let _taxes=[];
taxes:gridRef2?.current?.api?.getSelectedRows().forEach((a)=>{
  _taxes.push(a.id);
})
gridRef?.current?.api?.getSelectedRows().forEach(element => {
  
  _data.push({"staff_id":element.id,taxes:_taxes})

});
 
  console.clear();
  console.log(_data);
  genericPost(ENDPOINTS.ASSIGN_TAX, _data)
  .then((response) => {
      setIsLoading(false);
      setshowModal(false)
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
           
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
              global.show_operation_result({success:true,message:response.data.message})
             
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }

  const deleteTaxAssignments = () => {
    const selectedStaff = gridRef?.current?.api?.getSelectedRows() || [];
    
    if (selectedStaff.length === 0) {
      cogoToast.error("Please select at least one staff member", {});
      return;
    }

    const staffIds = selectedStaff.map(staff => staff.id);
    
    setIsLoading(true);
    genericPost(ENDPOINTS.DELETE_TAX_ASSIGNMENTS, { staff_ids: staffIds })
      .then((response) => {
        setIsLoading(false);
        setShowDeleteModal(false);
        if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            cogoToast.success(response.data.message || "Tax assignments deleted successfully", {
              hideAfter: 5,
            });
            global.show_operation_result({success: true, message: response.data.message || "Tax assignments deleted successfully"});
            // Refresh the employee data
            fetch_employee_data();
          } else {
            cogoToast.error(response.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again. " + err, {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
  
      <div className="row">
        <div className="col-md-3">
        <h1> ➊ Select Taxes </h1>
        <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef2}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          onRowSelected={(e) => {
            if (e.data?.id != null) {
              setSelected_taxes(gridRef2?.current?.api?.getSelectedRows())
            } else {
            
              return;
            }
          }}
          onSelectionChanged={(e) => {
            if ( e.data?.staff != null) {
              //calculate_tests();
            }
          }}

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
          //  params.api.showLoadingOverlay();
          }}
          rowData={taxes}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerCheckboxSelection: true,
              checkboxSelection: true,
              headerName: "Tax Name",
              field: "tax_name",
              sortable: true,
              filter: true,
            },
            
          
          ]}
        ></AgGridReact>
        
    
      </div> 

      <br/>
 <h1> 
Selected taxes : <b> {selected_taxes?.length} </b>    &nbsp; &nbsp; &nbsp;   

</h1>
<button className="btn btn-primary" 
 
onClick={(e)=>{
    setshowModal(true);
 
  }}>➌ Assign taxes</button>


  <button 
    className="btn btn-danger" 
    onClick={(e) => {
      const selectedStaff = gridRef?.current?.api?.getSelectedRows() || [];
      if (selectedStaff.length === 0) {
        cogoToast.error("Please select at least one staff member", {});
        return;
      }
      setShowDeleteModal(true);
    }}
    style={{ marginLeft: '10px' }}
  > 
    Delete Tax Assignment
  </button>
 
        </div>
        <div className="col-md-9">
        <h1> ➋ Select Staff </h1>

        <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          
          ref={gridRef}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          
          onRowSelected={(e) => {
            if (e.data?.staff_id != null) {
              
            } else {
            
              return;
            }
          }}
          

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
           params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },
            {
              headerCheckboxSelection: true,
              headerCheckboxSelectionFilteredOnly:true,
              checkboxSelection: true,
              headerName: "Staff ID",
              field: "staff_id",
              sortable: true,
              filter: true,
              maxWidth:120
            },
            {
         
              headerName: "Staff Name",
              field: "staff_name",
              sortable: true,
              filter: true,
            },
            
            {
              headerName: "Email ",
              field: "email",
              sortable: true,
              filter: true,
              maxWidth:200
            },
            {
              headerName: "Role  ",
              field: "role_name",
              sortable: true,
              filter: true,
              maxWidth:100
            },
            {
              headerName: "Office  ",
              field: "office_name",
              sortable: true,
              filter: true,
              maxWidth:100
            },
            {
              headerName: "Staff Taxes  ",
              field: "staff_taxes",
              sortable: true,
              filter: true,
              minWidth :300,
              onCellClicked:(e)=>{
                if (e.data?.staff_taxes && e.data.staff_taxes.length > 0) {
                  setSelectedStaffTaxes(e.data.staff_taxes);
                  setSelectedStaffName(e.data.staff_name || 'Staff');
                  setShowTaxesModal(true);
                } else {
                  cogoToast.info("No taxes assigned to this staff member", {});
                }
              },
              cellRendererFramework: (e) => {
                if (!e.data?.staff_taxes || e.data.staff_taxes.length === 0) {
                  return <span style={{ color: '#6c757d', fontStyle: 'italic' }}>No taxes</span>;
                }
                return (
                  <span style={{ cursor: 'pointer' }}>
                    {e.data.staff_taxes.map((a, index) => (
                      <Badge 
                        key={index} 
                        color="info" 
                        style={{ 
                          marginRight: '5px',
                          color:'white',
                          cursor: 'pointer',
                          fontSize: '11px'
                        }}
                      >
                        {a.tax_name}
                      </Badge>
                    ))}
                    
                  </span>
                );
              }
            },
            // {
            //   headerName: "staff_allowances  ",
            //   field: "staff_allowances",
            //   sortable: true,
            //   filter: true,
            //   cellRendererFramework: (e) => {

 
            //     return (
            //       <span>
            //       {e.data?.staff_allowances.map((a)=>{
            //         return <><Badge>{a.name}</Badge>&nbsp; </>
            //       })}
            //   </span>
            //     )}

            // },
           

          ]}
        ></AgGridReact>
      </div> 
          </div>
      </div>
    

<hr/>



 

      <Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             Confirm taxes to assign 
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        <form onSubmit={saveTaxes}>
          <h1> SELECTED STAFF  : {gridRef?.current?.api?.getSelectedRows().length} out of {rowData.length}</h1> <hr/>
          <h1>
         
            <ul>
            
            Selected Taxes : {selected_taxes.map((a)=>{
           return  <b>   <br/> ► { a.tax_name}  </b>
          }) }
          </ul>
          </h1>
          <br/>
          <br/>

          {!is_loading?
    <input  type="submit" disabled={gridRef?.current?.api?.getSelectedRows().length==0} className="btn btn-primary" value="Assign taxes" ></input> : <button className="btn btn-primary" disabled={true}><Spinner /> &nbsp; Processing..</button>  }

     
    </form>
        </ModalBody>
      
      </Modal>

      {/* Delete Tax Assignment Confirmation Modal */}
      <Modal
        isOpen={showDeleteModal}
        toggle={() => setShowDeleteModal(false)}
        backdrop={true}
      >
        <ModalHeader toggle={() => setShowDeleteModal(false)}>
          <div className="row">
            Confirm Delete Tax Assignment
          </div>
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: '10px' }}>
            <h4 style={{ color: '#dc3545', marginBottom: '20px' }}>
              ⚠️ Warning: This action cannot be undone
            </h4>
            <p style={{ fontSize: '16px', marginBottom: '15px' }}>
              Are you sure you want to delete tax assignments for the selected staff?
            </p>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '15px',
              borderRadius: '8px',
              border: '1px solid #dee2e6',
              marginBottom: '20px'
            }}>
              <h5 style={{ marginBottom: '10px', color: '#495057' }}>
                Total Staff Selected: <strong style={{ color: '#dc3545' }}>
                  {gridRef?.current?.api?.getSelectedRows().length || 0}
                </strong>
              </h5>
              <p style={{ margin: 0, color: '#6c757d', fontSize: '14px' }}>
                Tax assignments will be removed for all selected staff members.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            color="secondary" 
            onClick={() => setShowDeleteModal(false)}
            disabled={is_loading}
          >
            Cancel
          </Button>
          <Button 
            color="danger" 
            onClick={deleteTaxAssignments}
            disabled={is_loading}
          >
            {is_loading ? (
              <>
                <Spinner size="sm" /> &nbsp; Deleting...
              </>
            ) : (
              'Delete Tax Assignments'
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Staff Taxes View Modal */}
      <Modal
        isOpen={showTaxesModal}
        toggle={() => setShowTaxesModal(false)}
        backdrop={true}
        size="lg"
      >
        <ModalHeader toggle={() => setShowTaxesModal(false)}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>📋 Assigned Taxes</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: '10px' }}>
            <div style={{
              marginBottom: '20px',
              padding: '15px',
              backgroundColor: '#e7f3ff',
              borderRadius: '8px',
              border: '1px solid #b3d9ff'
            }}>
              <h5 style={{ margin: 0, color: '#0066cc', fontSize: '16px' }}>
                Staff: <strong>{selectedStaffName}</strong>
              </h5>
              <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
                Total Taxes: <strong>{selectedStaffTaxes.length}</strong>
              </p>
            </div>

            {selectedStaffTaxes.length > 0 ? (
              <div>
                <h6 style={{ 
                  marginBottom: '15px', 
                  color: '#495057',
                  fontSize: '15px',
                  fontWeight: '600'
                }}>
                  Tax List:
                </h6>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                  gap: '12px'
                }}>
                  {selectedStaffTaxes.map((tax, index) => (
                    <div
                      key={tax.id || index}
                      style={{
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        borderLeft: '4px solid #007bff',
                        transition: 'all 0.2s ease',
                        cursor: 'default'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#e9ecef';
                        e.currentTarget.style.transform = 'translateX(5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#f8f9fa';
                        e.currentTarget.style.transform = 'translateX(0)';
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <div style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: '#007bff'
                        }} />
                        <span style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#212529'
                        }}>
                          {tax.tax_name || 'N/A'}
                        </span>
                      </div>
                      {tax.id && (
                        <div style={{
                          marginTop: '5px',
                          fontSize: '11px',
                          color: '#6c757d',
                          fontFamily: 'monospace'
                        }}>
                          ID: {tax.id.substring(0, 8)}...
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                color: '#6c757d'
              }}>
                <p style={{ fontSize: '16px', margin: 0 }}>
                  No taxes assigned to this staff member
                </p>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            color="secondary" 
            onClick={() => setShowTaxesModal(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      
    </div>



  );
};

export default AssignStaffTax;
